module.exports = __webpack_public_path__ + "static/media/solutions.e5ebff0e.jpg";